export function IconSTC() {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none">
      <rect width="27" height="27" rx="4" fill="#087E86" />
      <circle cx="17.5" cy="13.5" r="4.5" fill="white" />
      <circle cx="10.5" cy="13.5" r="4.5" fill="white" fillOpacity="0.5" />
    </svg>
  )
}
